var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-change-password"},[_c('ui-page-header',{attrs:{"title":"修改密码"}}),_c('ui-stage',[_c('ui-admin-form',{attrs:{"model":_vm.changePasswordForm,"fields":_vm.changePasswordFields},on:{"submit":_vm.handleSubmitChangePassword}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }